module.exports = __webpack_public_path__ + "img/digital_icon_2.5002c98e.png";